import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  Flex,
  HStack,
  Portal,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useDeleteAccount, useLocalStorage } from 'hooks';
import { useTranslation } from 'localization';
import { routes } from 'statics';

import {
  ServiceDialogBody,
  ServiceDialogCloseTrigger,
  ServiceDialogFooter,
  ServiceDialogHeader,
  serviceDialogShellProps,
} from 'components';

import BorderedBox from '../BorderedBox';

const DeleteAccount: React.FC = () => {
  const { t } = useTranslation('component.settings.deleteAccount');
  const { setItem } = useLocalStorage();
  const navigate = useNavigate();

  const { open, onOpen, onClose } = useDisclosure();

  const { mutateAsync: delAcc } = useDeleteAccount();

  const deleteAccount = () => {
    delAcc({}).then(() => {
      setItem('magix-token', '');
      onClose();
      navigate(routes.auth.signUp.url);
    });
  };

  return (
    <BorderedBox
      borderColor="error"
      title={t('title')}
      w="100%"
      titleProps={{ color: 'error' }}
    >
      <Flex gap={4} flexDir="column">
        <Text>{t('description')}</Text>
        <Button w="max-content" size="sm" colorPalette="red" onClick={onOpen}>
          {t('deleteYourAccount')}
        </Button>
      </Flex>
      <Dialog.Root
        open={open}
        onOpenChange={(e: { open: boolean }) => {
          if (!e.open) {
            onClose();
          }
        }}
      >
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content {...serviceDialogShellProps()}>
              <ServiceDialogHeader>{t('modal.title')}</ServiceDialogHeader>
              <ServiceDialogCloseTrigger />
              <ServiceDialogBody>
                <Text fontSize="sm" color="body2">
                  {t('modal.description')}
                </Text>
              </ServiceDialogBody>
              <ServiceDialogFooter>
                <HStack justifyContent="flex-end" gap={2} flexWrap="wrap">
                  <Button variant="ghost" size="sm" h={10} onClick={onClose}>
                    {t('modal.cancel')}
                  </Button>
                  <Button
                    size="sm"
                    h={10}
                    colorPalette="red"
                    onClick={() => deleteAccount()}
                  >
                    {t('modal.deleteYourAccount')}
                  </Button>
                </HStack>
              </ServiceDialogFooter>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </BorderedBox>
  );
};

export default DeleteAccount;
